import { useEffect, useMemo } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import api from '../utils/api'
import { getNormalizedAdBaiduLandingUrl } from '../utils/adBaiduTracking'

/**
 * 百度推广追踪 hook（主站 /official、/install、/what-is、/local-deploy、/local-deploy2）
 * 读取 bd_vid 参数并上报访问记录
 * @param {string} landingPage - 落地页标识: official | install | what-is | local-deploy | local-deploy2
 */
export default function useBaidu2Tracking(landingPage) {
  const [searchParams] = useSearchParams()
  const location = useLocation()

  // 百度在 URL 末尾追加真实 bd_vid，取最后一个有效值
  const allBdVids = searchParams.getAll('bd_vid')
  const searchBdVid = allBdVids.length > 0 ? String(allBdVids[allBdVids.length - 1] || '').trim() : ''
  let bdVid = searchBdVid
  if (!bdVid) {
    const hash = String(location.hash || '')
    const queryIndex = hash.indexOf('?')
    if (queryIndex >= 0) {
      const hashParams = new URLSearchParams(hash.slice(queryIndex + 1))
      const hashBdVids = hashParams.getAll('bd_vid')
      bdVid = hashBdVids.length > 0 ? String(hashBdVids[hashBdVids.length - 1] || '').trim() : ''
    }
  }

  const landingUrl = useMemo(
    () => getNormalizedAdBaiduLandingUrl(window.location.href, bdVid),
    [bdVid, location.hash, location.pathname, location.search]
  )

  useEffect(() => {
    let cancelled = false

    const trackVisit = async () => {
      if (!bdVid || cancelled) return
      try {
        await api.post('/baidu2/visit', {
          bd_vid: bdVid,
          landingPage,
          page_url: landingUrl
        })
      } catch (error) {
        console.error('记录百度落地页访问失败:', error)
      }
    }

    trackVisit()
    return () => {
      cancelled = true
    }
  }, [bdVid, landingUrl, landingPage])

  return { bdVid, landingUrl, landingPage }
}
